import { render, staticRenderFns } from "./CandidatesFilters.vue?vue&type=template&id=0dc3ee6d&scoped=true&lang=pug&"
import script from "./CandidatesFilters.vue?vue&type=script&lang=js&"
export * from "./CandidatesFilters.vue?vue&type=script&lang=js&"
import style0 from "./CandidatesFilters.vue?vue&type=style&index=0&id=0dc3ee6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc3ee6d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
